module.exports = __webpack_public_path__ + "static/img/inscora-logo-principal.f3176cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inscora-logo-principal.png
// module id = PkX1
// module chunks = 2